import React, { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-toastify";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import FileImgPreview from "../../../component/molecules/fileImgPreview";
import Modal from "../../../component/templates/Modal";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import ColumnCommentModal from "../_component/columnCommentModal";
import DelBtn from "./../../../component/atoms/button/delBtn";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import EditBtn from "./../../../component/atoms/button/editBtn";
import DetailPageForm from "./../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "./../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "./../../../component/atoms/layout/detail/detailTop";
import MainLayout from "./../../../component/atoms/layout/mainLayout";
import Table from "./../../../component/atoms/layout/table/table";
import Td from "./../../../component/atoms/layout/table/td";
import Th from "./../../../component/atoms/layout/table/th";
import Tr from "./../../../component/atoms/layout/table/tr";
import DetailFormText from "./../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "./../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "./../../../component/atoms/text/detail/detailPageTitle";
import TableText from "./../../../component/atoms/text/table/tableText";
import GoBack from "./../../../component/molecules/goBack";
import Pagination from "./../../../component/molecules/pagination";
import Header from "./../../../component/organisms/header";
import Sidebar from "./../../../component/organisms/sidebar";
import { route } from "./../../../router/route";
import ColumnApi from "../../../api/column.api";
import moment from "moment";
import { homeUrl } from "../../../constants/url";

const ColumnPostDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [columnInfo, setColumnInfo] = useState({});
  const [commentList, setCommentList] = useState([]);

  useEffect(() => {
    getColumnInfo();
    getComment();
  }, [location]);

  const getColumnInfo = async () => {
    try {
      const response = (await ColumnApi.getPostById(id)).data.data.content;

      setColumnInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const getComment = async () => {
    try {
      const data = {
        columnPostId: id,
        page: searchParams.get("page"),
        size: pagination.size,
      };

      const response = (await ColumnApi.getComment(data)).data.data;

      setCommentList(response.content);
      setPagination({
        ...pagination,
        totalCount: response.totalCount ? response.totalCount : 0,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await ColumnApi.delPost(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 댓글 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [commentDeleteModalOpen, setCommentDeleteModalOpen] = useState(false);

  const commentDeleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await ColumnApi.delComment(data);
      toast(toastMsg.delete);
      setCommentDeleteModalOpen(false);
      setDelIdList([]);
      getComment();
    } catch (error) {
      errorHandler(error);
    }
  };

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
              <EditBtn
                onClick={() => {
                  navigate(route.column_post_edit + `/${id}`);
                }}
              />
            </div>
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태</DetailFormTitle>
                <DetailFormText>
                  {columnInfo.activation ? "활성" : "비활성"}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>작성일</DetailFormTitle>
                <DetailFormText>
                  {moment.utc(columnInfo.createdAt).format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>조회수</DetailFormTitle>
                <DetailFormText>{columnInfo.viewCount}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>스크랩</DetailFormTitle>
                <DetailFormText>{columnInfo.scrapCount}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>카테고리</DetailFormTitle>
                <DetailFormText>
                  {columnInfo.columnCategory?.title}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>
                  칼럼 페이지 썸네일
                  <br />
                  (권장사이즈 380*480)
                </DetailFormTitle>
                <FileImgPreview
                  fileName={columnInfo.thumbnailOriginFileNameColumn}
                  serverFileName={columnInfo.thumbnailServerFileNameColumn}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>
                  메인페이지 썸네일
                  <br />
                  (권장사이즈 585*222)
                </DetailFormTitle>
                <FileImgPreview
                  fileName={columnInfo.thumbnailOriginFileNameMain}
                  serverFileName={columnInfo.thumbnailServerFileNameMain}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>제목</DetailFormTitle>
                <DetailFormText>{columnInfo.title}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>내용</DetailFormTitle>
                <DetailFormText
                  onClick={() => {
                    window.open(
                      homeUrl + `/finlive/column/detail/${id}`,
                      "_blank"
                    );
                  }}
                  style={{ textDecorationLine: "underline", cursor: "pointer" }}
                >
                  미리보기
                </DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>댓글 관리</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <Table
                style={{
                  width: 964,
                }}
              >
                <colgroup>
                  {/* 날짜/시간 */}
                  <col width="227px" />
                  {/* 아이디 */}
                  <col width="93px" />
                  {/* 내용 */}
                  <col width="424px" />
                  {/* 좋아요 */}
                  {/* <col width="68px" /> */}
                  {/* 삭제하기 */}
                  <col width="79px" />
                  {/* 상세보기 */}
                  <col width="76px" />
                </colgroup>
                <thead>
                  <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                    <Th
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      <TableText>날짜/시간</TableText>
                    </Th>
                    <Th>
                      <TableText>아이디</TableText>
                    </Th>
                    <Th>
                      <TableText>내용</TableText>
                    </Th>
                    {/* <Th>
                      <TableText>좋아요</TableText>
                    </Th> */}
                    <Th>
                      <TableText>삭제하기</TableText>
                    </Th>
                    <Th>
                      <TableText>상세보기</TableText>
                    </Th>
                  </Tr>
                </thead>
                <tbody>
                  {commentList.map((item, index) => {
                    return (
                      <Tr
                        key={index}
                        style={{ height: "59px", background: "#fff" }}
                      >
                        <Td
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <TableText>
                            {moment(item.createdAt).format(
                              "YYYY/MM/DD HH:mm:ss"
                            )}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText
                            style={{
                              width: "80px",
                            }}
                          >
                            {item.member?.account}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText
                            style={{
                              width: "400px",
                            }}
                          >
                            {item.content}
                          </TableText>
                        </Td>
                        {/* <Td>
                          <TableText>1</TableText>
                        </Td> */}
                        <Td>
                          <TableDelBtn
                            onClick={() => {
                              const delList = [item];
                              setDelIdList(delList.map((item) => item.id));
                              setCommentDeleteModalOpen(true);
                            }}
                          />
                        </Td>
                        <Td>
                          <DetailBtn
                            onClick={() => {
                              setSelectedData(item);
                              setDetailModalOpen(true);
                            }}
                          />
                        </Td>
                      </Tr>
                    );
                  })}
                </tbody>
              </Table>
              <Pagination
                route={route.column_post_detail + `/${id}`}
                queryString={""}
                currentPage={page}
                totalPages={pagination.totalPages}
                rangeSize={pagination.rangeSize}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}

      {commentDeleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setCommentDeleteModalOpen}
          onClick={() => {
            commentDeleteFunc();
          }}
        />
      ) : null}

      {detailModalOpen ? (
        <ColumnCommentModal
          data={selectedData}
          setModalOpen={setDetailModalOpen}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default ColumnPostDetail;
